import { render } from "./CustomFooter.vue?vue&type=template&id=3dfac6f6&scoped=true&ts=true"
import script from "./CustomFooter.vue?vue&type=script&lang=ts"
export * from "./CustomFooter.vue?vue&type=script&lang=ts"

import "./CustomFooter.vue?vue&type=style&index=0&id=3dfac6f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfac6f6"]])

export default __exports__